import React from 'react';
import { useTranslation } from 'react-i18next';
import { HistoryList } from 'src/components/History';
import DefaultLayout from 'src/components/layouts/DefaultLayout';

export const HistoryPage = () => {
  const { t } = useTranslation('admin', { keyPrefix: 'history' });

  return (
    <DefaultLayout title={t('title')}>
      <HistoryList />
    </DefaultLayout>
  );
};
